<template>
	<ul>
		<li class="content-list" @click="listClick">
			<ProviderExpand :providerwise-patient-count="providerwisePatientCount('today')"
				:total-count="totalCount['today']"
                toRoute="/upcoming/today"
                type="upcoming"
                day="today">
					Appt - Today
			</ProviderExpand>
		</li>
        <li class="content-list" @click="listClick">
			<ProviderExpand :providerwise-patient-count="providerwisePatientCount('tomorrow')"
				:total-count="totalCount['tomorrow']"
                to-route="/upcoming/tomorrow"
                type="upcoming"
                day="tomorrow">
					Appt - Tomorrow
			</ProviderExpand>
		</li>
        <li class="content-list" @click="listClick">
			<ProviderExpand :providerwise-patient-count="providerwisePatientCount('next_seven')"
				:total-count="totalCount['next_seven']"
                to-route="/upcoming/next_seven"
                type="upcoming"
                day="next_seven">
					Appt - Next 7 days
			</ProviderExpand>
		</li>
	</ul>
</template>

<script>
import { mapActions, mapMutations, mapGetters, mapState } from 'vuex'
import SidebarList from '.'
import ProviderExpand from './ProviderExpand'
import isEmptyObject from '@/module/util/empty-object'

export default {
    name: 'sidebar-upcoming-list',
    extends: SidebarList,

    data() {
        return {
            totalCount: {
                today: 0,
                tomorrow: 0,
                next_seven: 0
            }
        }
    },


    mounted() {
        if (this.getUserType === 'observer') {
            document.querySelectorAll('.content-list a.router-link-active').forEach(element => element.style.backgroundColor = '#1B98CD')
			document.querySelectorAll('.content-list a.router-link-active:not(.active)').forEach(element => element.style.backgroundColor = '#ffffff')
		}
    },


    methods: {
		listClick() {
			if (this.getUserType === 'observer') {
                document.querySelectorAll('.content-list a').forEach(element => element.style.backgroundColor = '#F8F8F8')
                document.querySelectorAll('.content-list a.router-link-active').forEach(element => element.style.backgroundColor = '#1B98CD')
				document.querySelectorAll('.content-list a.router-link-active:not(.active)').forEach(element => element.style.backgroundColor = '#ffffff')
			}
		},
        providerwisePatientCount(day) {
            let tempObj = {}

            if(this.overview && 
                this.overview.schedule && 
                this.overview.schedule[day] && 
                Object.keys(this.overview.schedule[day]).length > 0) {
                    this.totalCount[day] = this.findPatientWiseCntForDay(this.overview.schedule[day])
                    return this.overview.schedule[day]
                    // Object.entries(this.overview.schedule[day]).forEach((provWisePat) => {
                    //     if(provWisePat[1].length > 0) tempObj[provWisePat[0]] = provWisePat[1]
                    // })
            }

            // this.totalCount[day] = this.findPatientWiseCntForDay(tempObj)
            // return tempObj
        },
        findPatientWiseCntForDay(provWisePatient) {
            let res = Object.values(provWisePatient).reduce((acc, curr) => {
                acc += curr.length
                return acc
            }, 0)
            return res
        }
	},

    computed: {
        ...mapState('provider', [
            'overview',
            'providerPatients'
        ]),
        ...mapGetters('provider', [
            'getProviderPatientList',
            'getAllProviderPatientList',
            'getProviderList'
        ]),
        ...mapGetters(['getUserType']),
    },

    components: {
        ProviderExpand
    }
}
</script>

<style lang="scss" scoped>
@import "style.scss";
</style>
